import React, { useState } from "react";
import PropTypes from "prop-types";
// ui
import Box from "@mui/material/Box";
// style
import { createStyles, makeStyles, styled } from "@material-ui/styles";
// utils
import { isEmpty } from "../../utils";

//
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
  })
);

const StyledBox = styled(Box)(({ theme }) => ({
  "&:hover": {
    cursor: "pointer",
  },
}));

//
const Logo = ({ imgProps, imgBoxProps }) => {
  // style
  const classes = useStyles();
  // props
  const { imgSrc, imgWidth } = imgProps;

  // local state

  return (
    <Box display="flex">
      <StyledBox mr={2} {...imgBoxProps}>
        {imgSrc && imgWidth && (
          <img src={imgSrc} alt="sna logo" width={imgWidth} />
        )}
      </StyledBox>
    </Box>
  );
};

Logo.propTypes = {
  imgProps: PropTypes.objectOf(PropTypes.any),
  imgBoxProps: PropTypes.objectOf(PropTypes.any),
};

Logo.defaultProps = {
  imgProps: {},
  imgBoxProps: {},
};

export default Logo;
